/* eslint-disable camelcase */
// 语言配置
const sysLan = {
  zh: { // 中文
    publish: '发布',

    edit: '修改',
    add: '添加',
    delete: '删除',
    view: '查看',
    cut: '剪切',
    copy: '复制',
    paste: '粘贴',
    save: '保存',
    cancel: '取消',
    derivation: '确认导出吗?',
    query: '查询',
    login: '登录',
    logout: '退出',
    // eslint-disable-next-line camelcase
    pre_step: '上一步',
    // eslint-disable-next-line camelcase
    next_step: '下一步',
    refresh: '刷新',
    reset: '重置',
    set: '设置',
    first_page: '第一页',
    last_page: '最后一页',
    pre_page: '上一页',
    next_page: '下一页',
    enclosure: '附件',
    download_enclosure: '下载附件',
    open: '展开',
    putItAway: '收起',
    query_more: '高级查询',
    search: '查询',
    export: '导出',
    qualified: '导出合格名单',
    noQualified: '导出不合格名单',
    postgraduate: '转为研究生',
    import: '导入',
    scheduleImport: '导入教学进度表',
    print: '打印',
    schoolPrint: '按学校打印',
    majorPrint: '按专业打印',
    batchPrint: '批量打印',
    mergePrint: '合并打印',
    expensePrint: '住宿费打印',
    practicePrint: '实习费打印',
    release: '发布',
    revoke: '撤销',
    attend: '参加',
    report: '上报',
    operate: '审核',
    examine: '审核',
    arrange: '安排',
    submit: '提交',
    disable: '禁用',
    enable: '启用',
    new: '新建',
    resetPassword: '重置密码',
    transfer: '部门调动',
    headImage: '头像下载',
    poll: '投票结果',
    score: '评分',
    elected: '获选',
    Announcements: '发布公告',
    analysis: '查看分析',
    analysisReport: '分析报告',
    return: '返回',
    details: '详情',
    courseWare: '上传课件',
    experience: '心得体会',
    evaluate: '评价',
    viewEvaluate: '查看评价',
    choice: '选择',
    attachment: '附件管理',
    authorizations: '权限设置',
    payment: '支付',
    editPayment: '修改支付时间',
    warehousing: '设备入库',
    revert: '归还',
    consumption: '耗材入库',
    inventory: '盘点',
    adopt: '通过',
    noAdopt: '拒绝',
    reject: '驳回',
    application: '申请列表',
    use: '已使用',
    downloadVideo: '下载视频',
    debugging: '调试',
    authorization: '授权',
    cardReading: '读卡',
    cdaView: 'CAD视图',
    commonView: '普通视图',
    openClass: '开课',
    attendClass: '上课',
    finishClass: '下课',
    sure: '确定',
    result: '生成结业成绩',
    complete: '完成',
    downloadTemplate: '下载模板',
    upload: '上传',
    register: '报到',
    replace: '更换',
    arrangeRotation: '安排轮转',
    paymentConfirmation: '缴费确认',
    arrangement: '自动安排',
    administrativeExport: '按科室导出',
    staffExport: '按人员导出',
    trim: '微调',
    recovery: '恢复',
    suspend: '暂停',
    termination: '终止',
    close: '关闭',
    closeClass: '合班',
    lastWeek: '上一周',
    nextWeek: '上一周',
    allowanceGenerating: '生成考务津贴',
    write: '填写',
    certificate: '导出教材申领单',
    grant: '导出课时费发放清单',
    sectionInformation: '科室信息',
    departmentList: '下级科室列表',
    end: '结束'
  }
}

export default sysLan
